import { PlayIcon as PhosphorPlayIcon } from "@phosphor-icons/react/dist/ssr/Play";

import { createAppIcon } from "@/components/createAppIcon";

export const PlayIcon = /* @__PURE__ */ createAppIcon(PhosphorPlayIcon);
